<template>
<div>
  <a v-if="mobile" href="#" class="cx-link--stack" tabindex="0"
    @click.prevent="showSearchModal = true"
    :aria-label="$t('action.search')"
  >
    <span class="cx-link__icon" aria-hidden="true">
      <i class="far fa-search"></i>
    </span>
    <span class="cx-link__text">
      {{$t("action.search")}}
    </span>
  </a>
  <a v-else href="#" class="cx-link" tabindex="0"
    @click.prevent="showSearchModal = true"
    :aria-label="$t('action.search')"
  >
    <span class="cx-link__icon" aria-hidden="true">
      <i class="fal fa-search"></i>
    </span>
    <span>
      {{$t("action.search")}}
    </span>
  </a>
  <search-modal 
    v-if="showSearchModal"
    :chatbot-keyword="chatbotKeyword"
    v-on:cancel="cancelSearch"
  ></search-modal>
</div>
</template>

<script>
import SearchModal from '@/components/SearchModal';

export default {
  name: 'main-header-search-btn',
  uit() {
    return [
      ['action', [
        'search',
      ]],
    ];
  },
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chatbotKeyword: '',
      showSearchModal: false,
    }
  },
  mounted() {
    if (this.$route.query.opener === 'chatbot' && this.$route.query.keyword) {
      // chatbot opener 帶入的 keyword 也需要 trim，避免網址上出現 %20 / 搜尋條件不一致
      this.chatbotKeyword = String(this.$route.query.keyword || '').trim();
      this.showSearchModal = true;
    }
  },
  methods: {
    cancelSearch() {
      this.showSearchModal = false
      this.chatbotKeyword = '';
    },
  },
  components: {
    SearchModal
  }
};
</script>
